<template>
  <div class="header-container">
    <router-link to="/">Home</router-link>
    <router-link to="/resume">Resume</router-link>
    <router-link to="/contact">Contact</router-link>
  </div>
</template>

<script>
export default {
  name: 'AppHeader'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only #FFFFFF;-->
<style scoped>
.header-container {
  background-image: linear-gradient(-20deg, #fc6076 0%, #ff9a44 100%);
  height: 23px;
  top: 0px;
  padding: 8px;
  margin-left: -9px;
  width: 100%;
  align-items: center;
  text-align: center;
  position: absolute;
}
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 6px;
}
a {
  color: white;
  text-decoration: none !important;
  text-transform: uppercase;
  letter-spacing: .1rem;
  font-weight: 600;
  font-size: 12px;
  padding:0 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/AppHeader.vue